import { createMeetPeer } from './peer/index.js';
import { signallerUrl, cachedIceServers } from '../lib/backend.js';

let injected = null;
let real = null;

/**
 * The peer client every session uses. Configured by exactly the three things
 * the peer library takes: where the signaller is, which ICE servers to use
 * (from the backend's /v1/ice) and what credential to present for hosting.
 */
export function getPeer() {
  if (injected) return injected;
  real ??= createMeetPeer({
    signallerUrl,
    iceServers: cachedIceServers,
    // No bearer token: a signed-in host is recognised by the session cookie the browser
    // sends with the WebSocket handshake (same origin). A session that holds a meeting lease
    // presents `lease.<secret>` per call instead (see RoomSession), so a successor host or a
    // guest-to-guest link never needs the cookie.
    token: () => undefined,
  });
  return real;
}

/** Test hook: use this peer client (with serve/connect) instead of the real one. Pass null to restore. */
export function setPeerClient(peer) {
  injected = peer;
}
